<template>
  <v-row>
    <v-col cols="auto" class="pa-0">
      <v-btn
        text
        @click="$emit('back')"
        color="secondary"
        class="font-weight-bold"
      >
        <v-icon class="mr-2">
          keyboard_arrow_left
        </v-icon>
        Go Back
      </v-btn>
    </v-col>
    <v-col cols="12">
      <resource-card :resource="resource" disable-expansion></resource-card>
    </v-col>
    <template v-if="this.resource.sentInstancesCount == 0">
      <v-col cols="12">
        <v-card>
          <v-row>
            <v-col cols="auto">
              <v-img :src="$images.WAITING" width="150" class="mx-6"></v-img>
            </v-col>
            <v-col cols="9">
              <v-card-title>
                We're waiting on training resources to be shared!
              </v-card-title>
              <v-card-subtitle>
                No training resources have been sent at this time. Come back
                later!
              </v-card-subtitle>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12" sm="6" md="4">
        <reporting-filter
          v-model="filter"
          v-on:change="loadData"
          v-if="resource.id"
        ></reporting-filter>
      </v-col>
      <v-col cols="12" sm="6" md="8">
        <v-row>
          <v-col cols="12" class="pt-0">
            <engagement-card
              :loading="loading"
              data="reporting/overview"
              horizontal
              isResources
              uniqueTitle="Unique Resources"
              v-on:click="selectUser"
            ></engagement-card>
          </v-col>
          <v-col cols="12">
            <resource-sent-user-list
              :loading="loading"
            ></resource-sent-user-list>
          </v-col>
        </v-row>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import ReportingFilter from "@/components/reporting/ReportingFilter";
import ResourceSentUserList from "@/components/resources/ResourceSentUserList";
import EngagementCard from "@/components/reporting/EngagementCard";
import ResourceCard from "@/components/resources/ResourceCard";
export default {
  name: "ResourceReport",
  components: {
    ReportingFilter,
    ResourceSentUserList,
    EngagementCard,
    ResourceCard
  },
  props: {
    filter: { type: Object },
    resource: { type: Object }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters({})
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      Promise.all([
        this.$store.dispatch("reporting/getResourceReport", this.filter)
      ]).finally(() => {
        this.loading = false;
      });
    },
    selectUser(userId) {
      this.filter.userId = userId;
      this.loadData();
    }
  }
};
</script>
